import React, { useMemo, useState, useEffect, useReducer } from "react";
import { Edit } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import api from "../../../../_core/api";
import * as S from "../styles";
import { Button, Table, Modal, Option } from "../../../../_core/_components";
import { handleErrors, success } from "../../../../_core/services/toast";
import { FullScreenLoading } from "../../../../_core/_components/fullscreen-loading";
import { INITIAL_STATE, reducer } from "./reducer";
import ModalContent from "./modal-content";

export const ConfiguracaoComunicado: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [configuracaoComunicadoList, setConfiguracaoComunicadoList] = useState<
    any[]
  >([]);
  const [shoppingsList, setShoppingsList] = useState<Option[]>([]);
  const [tipoComunicadoList, setTipoComunicadoList] = useState<Option[]>([]);
  const [tipoDividaList, setTipoDividaList] = useState<Option[]>([]);
  const [canalList, setCanalList] = useState<Option[]>([]);
  const [form, dispatch] = useReducer(reducer, undefined);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const [
        response,
        responseTipoComunicado,
        responseTipoDivida,
        responseCanal,
        responseShoppings,
      ] = await Promise.all([
        api.post(`/api/cartas/comunicado/buscar`, {
          descricaoComunicado: "",
          mascaraData: "",
          parametroVencimento: "",
          flagAtivo: true,
          flagDadosTitulo: false,
          flagDadosFiador: false,
        }),
        api.post(`/api/cartas/tipoComunicado/buscar`, {
          nomeTipoComunicado: "",
          codigoTipoComunicado: "",
        }),
        api.post(`/api/cartas/tipodivida/buscar`, {
          nomeDivida: "",
          codigoContrato: "",
          tipoDocumentos: "",
          tipoMovimentos: "",
        }),
        api.post(`/api/cartas/canal/buscar`, {
          nomeCanal: "",
        }),
        api.get("/api/cartas/shopping/buscar"),
      ]);
      setTipoComunicadoList(
        responseTipoComunicado.data.content.map((e) => ({
          label: e.nomeTipoComunicado,
          value: e.idTipoComunicado,
        }))
      );
      setTipoDividaList(
        responseTipoDivida.data.content.map((e) => ({
          label: e.nomeDivida,
          value: e.idTipoDivida,
        }))
      );
      setConfiguracaoComunicadoList(response.data.content);
      setCanalList(
        responseCanal.data.content.map((e) => ({
          label: e.nomeCanal,
          value: e.idCanal,
        }))
      );
      setShoppingsList(
        responseShoppings.data.content.map((e) => ({
          value: e.unidadeEconomica,
          label: `${e.nomeShopping} - ${e.unidadeEconomica}`,
        }))
      );
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  };

  const onClickSave = async () => {
    try {
      setIsLoading(true);
      const payload = {
        ...form,
        unidadesEconomicas: form.shoppings.map((e) => e.value),
      };
      delete payload.shoppings;
      await api.post(`/api/cartas/comunicado/salvar`, payload);
      dispatch({ type: "UNSET_CONFIGURACAO_COMUNICADO" });
      const { data } = await api.post(`/api/cartas/comunicado/buscar`, {
        descricaoComunicado: "",
        mascaraData: "",
        parametroVencimento: "",
        flagAtivo: true,

        idCanal: undefined,
        idTipoDivida: undefined,
        idTipoComunicado: undefined,
        idComunicado: undefined,
      });
      setConfiguracaoComunicadoList(data.content);
      success("Comunicado salvo com sucesso.");
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  };

  const getShoppings = (shoppings: any[]) => {
    const unidadesEconomicas = shoppings.map((e) => e.unidadeEconomica);
    return shoppingsList.filter((e) => unidadesEconomicas.includes(e.value));
  };

  const data = useMemo(() => {
    return configuracaoComunicadoList.map((e) => ({
      ...e,
      canalStr: e.canal.nomeCanal,
      tipoComunicadoStr: e.tipoComunicado.nomeTipoComunicado,
      tipoDividaStr: e.tipoDivida.nomeDivida,
      flagDadosFiador: e.flagDadosFiador ? "Sim" : "Não",
      ativoStr: e.flagAtivo ? "Sim" : "Não",
      editar: (
        <IconButton
          onClick={() =>
            dispatch({
              type: "SET_CONFIGURACAO_COMUNICADO",
              payload: {
                ...e,
                idCanal: e.canal.idCanal,
                idTipoDivida: e.tipoDivida.idTipoDivida,
                idTipoComunicado: e.tipoComunicado.idTipoComunicado,
                shoppings: getShoppings(e.shoppings),
              },
            })
          }
        >
          <Edit />
        </IconButton>
      ),
    }));
  }, [configuracaoComunicadoList, shoppingsList]);

  return (
    <>
      {form && (
        <Modal
          size="xl"
          title="Adicionar / Alterar Configuração Comunicado"
          onClose={() => dispatch({ type: "UNSET_CONFIGURACAO_COMUNICADO" })}
          content={
            <ModalContent
              form={form}
              dispatch={dispatch}
              arrCanal={canalList}
              arrTipoComunicado={tipoComunicadoList}
              arrTipoDivida={tipoDividaList}
              arrShoppings={shoppingsList}
            />
          }
          actionItems={[<Button onClick={onClickSave} text="Salvar" />]}
        />
      )}
      <FullScreenLoading isEnabled={isLoading} />
      <S.DataContainer>
        <S.TopBar>
          <S.SearchBar></S.SearchBar>
          <Button
            text="Novo"
            onClick={() =>
              dispatch({
                type: "SET_CONFIGURACAO_COMUNICADO",
                payload: INITIAL_STATE,
              })
            }
            styles={{ width: 100 }}
          />
        </S.TopBar>
        {configuracaoComunicadoList.length > 0 && (
          <Table
            columns={[
              { label: "Descrição", key: "descricaoComunicado" },

              {
                label: "Quantidade mínima de dias em aberto",
                key: "parametroVencimento",
              },
              {
                label: "Quantidade mínima de boletos",
                key: "quantidadeMinimaBoletos",
              },
              { label: "Nome do arquivo", key: "nomeArquivo" },
              { label: "Canal", key: "canalStr" },
              { label: "Tipo comunicado", key: "tipoComunicadoStr" },
              { label: "Tipo dívida", key: "tipoDividaStr" },
              { label: "Ativo", key: "ativoStr" },
              { label: "Fiador", key: "flagDadosFiador" },
              { label: "Editar", key: "editar" },
            ]}
            data={data}
          />
        )}
      </S.DataContainer>
    </>
  );
};
